import { Card, CardContent } from "@/components/Primitives/Card"
import { Text } from "@/components/Primitives/Text"
import { Button } from "@/components/Primitives/Button"
import { useNavigate } from "react-router-dom"
import { useConfig } from "@/hooks/useConfig"
import { AuthLayout } from "@/components/Primitives/AuthLayout"

export function ResetPasswordSuccessPage() {
  const navigate = useNavigate()
  const { t } = useConfig()

  return (
    <AuthLayout
      description={t("config_reset_password_success_description")}
      imageUrl="/images/open-box.webp"
    >
      <div className="w-full max-w-md">
        <Card className="px-2 py-10 lg:px-8 justify-center">
          <CardContent className="flex flex-col items-center gap-10">
            <img
              src="/images/success.png"
              alt="Success icon"
              width={94}
              height={94}
            />
            <div className="flex flex-col items-center gap-4">
              <Text variant="h3" bold className="text-center">
                {t("config_reset_password_success_title")}
              </Text>
              <Text variant="paragraph" className="text-center">
                {t("config_reset_password_success_description")}
              </Text>
            </div>
            <Button
              className="font-semibold w-full"
              onClick={() => navigate("/login")}
            >
              {t("config_reset_password_success_button")}
            </Button>
          </CardContent>
        </Card>
      </div>
    </AuthLayout>
  )
}
